import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'

export interface GlobalSearchResult {
  id: string
  type: 'lead' | 'opportunity' | 'company' | 'contact'
  label: string
  subtitle?: string | null
}

export interface GlobalSearchResponse {
  leads: GlobalSearchResult[]
  opportunities: GlobalSearchResult[]
  companies: GlobalSearchResult[]
  contacts: GlobalSearchResult[]
}

function useDebounced<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return debounced
}

export function useGlobalSearch(query: string) {
  const debouncedQuery = useDebounced(query.trim(), 250)
  return useQuery({
    queryKey: ['global-search', debouncedQuery],
    queryFn: async () => {
      const { data } = await api.get<GlobalSearchResponse>('/v1/search/global', { params: { q: debouncedQuery } })
      return data
    },
    enabled: debouncedQuery.length >= 2,
    staleTime: 30_000,
  })
}
